import {Source} from "@amplitude/experiment-js-client";
import {add, experiment, flush, getDeviceId, getUserId, Identify, identify, initAll, reset, setUserId, Types} from "@amplitude/unified";
import type {UnifiedOptions} from "@amplitude/unified/lib/cjs/unified";

import {IAmplitudeExperimentVariants} from "../types/IAmplitudeExperimentVariants";
import {defaultAmplitudeLogger, IAmplitudeLogger} from "../types/IAmplitudeLogger";

let isAmplitudeInitialized = false;
let amplitudeInitializationPromise: Promise<void> | null = null;

const ALLOWED_AMPLITUDE_ENVIRONMENTS = ["production", "stage:top", "stage:dev", "stage:ovh", "local"] as const;
const APP_ENVIRONMENT_PROPERTY = "app_environment";
const AMPLITUDE_ENVIRONMENT_PLUGIN_NAME = "app-environment-enrichment";

type TAmplitudeEnvironment = (typeof ALLOWED_AMPLITUDE_ENVIRONMENTS)[number];

interface IInitAmplitudeParams {
    amplitudeApiKey?: string;
    deploymentKey?: string;
    initialVariants?: IAmplitudeExperimentVariants;
    userId?: string;
    isBrowser?: boolean;
    logger?: IAmplitudeLogger;
    environment?: string;
}

const validateAmplitudeEnvironment = (environment: string): TAmplitudeEnvironment => {
    if (ALLOWED_AMPLITUDE_ENVIRONMENTS.includes(environment as TAmplitudeEnvironment)) {
        return environment as TAmplitudeEnvironment;
    }

    throw new Error(`Invalid Amplitude environment "${environment}". Allowed values: ${ALLOWED_AMPLITUDE_ENVIRONMENTS.join(", ")}`);
};

export const initAmplitude = ({
    amplitudeApiKey,
    deploymentKey,
    initialVariants,
    userId,
    isBrowser = false,
    logger: _logger = defaultAmplitudeLogger,
    environment
}: IInitAmplitudeParams): void => {
    if (!amplitudeApiKey) {
        // no key, silent exit
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && !isBrowser) {
        return;
    }
    // initialize only once
    if (isAmplitudeInitialized || amplitudeInitializationPromise) {
        return;
    }

    const validatedEnvironment = environment ? validateAmplitudeEnvironment(environment) : undefined;
    const options: UnifiedOptions = {
        serverZone: "EU",
        analytics: {
            autocapture: true
        }
    };

    if (deploymentKey) {
        options.experiment = {
            deploymentKey,
            initialVariants: initialVariants ?? {},
            source: Source.InitialVariants
        };
    }

    if (validatedEnvironment) {
        const environmentPlugin: Parameters<typeof add>[0] = {
            name: AMPLITUDE_ENVIRONMENT_PLUGIN_NAME,
            type: "enrichment",
            async execute(event) {
                event.event_properties = {
                    ...(event.event_properties ?? {}),
                    [APP_ENVIRONMENT_PROPERTY]: validatedEnvironment
                };

                return event;
            }
        };

        add(environmentPlugin);
    }

    amplitudeInitializationPromise = Promise.resolve(initAll(amplitudeApiKey, options))
        .then(() => {
            isAmplitudeInitialized = true;
        })
        .catch((error) => {
            amplitudeInitializationPromise = null;
            throw error;
        });

    if (userId) {
        setUserId(userId);
    }

    if (validatedEnvironment) {
        const identifyObj = new Identify();

        identifyObj.set(APP_ENVIRONMENT_PROPERTY, validatedEnvironment);
        identify(identifyObj);
    }
};

export const waitForAmplitudeInitialization = async (): Promise<void> => {
    await amplitudeInitializationPromise;
};

export const setAmplitudeUserId = (userId: string | undefined): void => {
    if (isAmplitudeInitialized) {
        setUserId(userId);
    }
};

export const setAmplitudeUserProperties = (properties: Record<string, Types.ValidPropertyType>): void => {
    if (isAmplitudeInitialized) {
        const identifyObj = new Identify();

        for (const [key, value] of Object.entries(properties)) {
            identifyObj.set(key, value);
        }

        identify(identifyObj);
    }
};

export const flushAmplitude = async (): Promise<void> => {
    if (!isAmplitudeInitialized) {
        return;
    }

    await flush().promise;
};

export const resetAmplitude = (): void => {
    if (isAmplitudeInitialized) {
        reset();
    }
};

export const getAmplitudeUserId = (): string | undefined => {
    if (!isAmplitudeInitialized) {
        return undefined;
    }

    return getUserId() ?? undefined;
};

export const getAmplitudeDeviceId = (): string | undefined => {
    if (!isAmplitudeInitialized) {
        return undefined;
    }

    return getDeviceId() ?? undefined;
};

export {experiment};
import {Source} from "@amplitude/experiment-js-client";
import {add, experiment, flush, getDeviceId, getUserId, Identify, identify, initAll, reset, setUserId, Types} from "@amplitude/unified";
import type {UnifiedOptions} from "@amplitude/unified/lib/cjs/unified";

import {IAmplitudeExperimentVariants} from "../types/IAmplitudeExperimentVariants";
import {defaultAmplitudeLogger, IAmplitudeLogger} from "../types/IAmplitudeLogger";

let isAmplitudeInitialized = false;
let amplitudeInitializationPromise: Promise<void> | null = null;

const ALLOWED_AMPLITUDE_ENVIRONMENTS = ["production", "stage:top", "stage:dev", "stage:ovh", "local"] as const;
const APP_ENVIRONMENT_PROPERTY = "app_environment";
const AMPLITUDE_ENVIRONMENT_PLUGIN_NAME = "app-environment-enrichment";

type TAmplitudeEnvironment = (typeof ALLOWED_AMPLITUDE_ENVIRONMENTS)[number];

interface IInitAmplitudeParams {
    amplitudeApiKey?: string;
    deploymentKey?: string;
    initialVariants?: IAmplitudeExperimentVariants;
    userId?: string;
    isBrowser?: boolean;
    logger?: IAmplitudeLogger;
    environment?: string;
}

const validateAmplitudeEnvironment = (environment: string): TAmplitudeEnvironment => {
    if (ALLOWED_AMPLITUDE_ENVIRONMENTS.includes(environment as TAmplitudeEnvironment)) {
        return environment as TAmplitudeEnvironment;
    }

    throw new Error(`Invalid Amplitude environment "${environment}". Allowed values: ${ALLOWED_AMPLITUDE_ENVIRONMENTS.join(", ")}`);
};

export const initAmplitude = ({
    amplitudeApiKey,
    deploymentKey,
    initialVariants,
    userId,
    isBrowser = false,
    logger: _logger = defaultAmplitudeLogger,
    environment
}: IInitAmplitudeParams): void => {
    if (!amplitudeApiKey) {
        // no key, silent exit
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && !isBrowser) {
        return;
    }
    // initialize only once
    if (isAmplitudeInitialized || amplitudeInitializationPromise) {
        return;
    }

    const validatedEnvironment = environment ? validateAmplitudeEnvironment(environment) : undefined;
    const options: UnifiedOptions = {
        serverZone: "EU",
        analytics: {
            autocapture: true
        }
    };

    if (deploymentKey) {
        options.experiment = {
            deploymentKey,
            initialVariants: initialVariants ?? {},
            source: Source.InitialVariants
        };
    }

    if (validatedEnvironment) {
        const environmentPlugin: Parameters<typeof add>[0] = {
            name: AMPLITUDE_ENVIRONMENT_PLUGIN_NAME,
            type: "enrichment",
            async execute(event) {
                event.event_properties = {
                    ...(event.event_properties ?? {}),
                    [APP_ENVIRONMENT_PROPERTY]: validatedEnvironment
                };

                return event;
            }
        };

        add(environmentPlugin);
    }

    amplitudeInitializationPromise = Promise.resolve(initAll(amplitudeApiKey, options))
        .then(() => {
            isAmplitudeInitialized = true;
        })
        .catch((error) => {
            amplitudeInitializationPromise = null;
            throw error;
        });

    if (userId) {
        setUserId(userId);
    }

    if (validatedEnvironment) {
        const identifyObj = new Identify();

        identifyObj.set(APP_ENVIRONMENT_PROPERTY, validatedEnvironment);
        identify(identifyObj);
    }
};

export const waitForAmplitudeInitialization = async (): Promise<void> => {
    await amplitudeInitializationPromise;
};

export const setAmplitudeUserId = (userId: string | undefined): void => {
    if (isAmplitudeInitialized) {
        setUserId(userId);
    }
};

export const setAmplitudeUserProperties = (properties: Record<string, Types.ValidPropertyType>): void => {
    if (isAmplitudeInitialized) {
        const identifyObj = new Identify();

        for (const [key, value] of Object.entries(properties)) {
            identifyObj.set(key, value);
        }

        identify(identifyObj);
    }
};

export const flushAmplitude = async (): Promise<void> => {
    if (!isAmplitudeInitialized) {
        return;
    }

    await flush().promise;
};

export const resetAmplitude = (): void => {
    if (isAmplitudeInitialized) {
        reset();
    }
};

export const getAmplitudeUserId = (): string | undefined => {
    if (!isAmplitudeInitialized) {
        return undefined;
    }

    return getUserId() ?? undefined;
};

export const getAmplitudeDeviceId = (): string | undefined => {
    if (!isAmplitudeInitialized) {
        return undefined;
    }

    return getDeviceId() ?? undefined;
};

export {experiment};
